import { useAuthDetails } from "@/context/auth-context";

export function useUserUuid(): string | null {
  const authDetails = useAuthDetails();

  return authDetails?.uuid ?? null;
}
